module.exports = __webpack_public_path__ + "img/card-project4.282e960f.jpg";